require('../modules/es6.object.to-string');
require('../modules/es6.string.iterator');
require('../modules/web.dom.iterable');
require('../modules/es6.set');
require('../modules/es7.set.to-json');
module.exports = require('../modules/$.core').Set;


/*****************
 ** WEBPACK FOOTER
 ** ./~/core-js/library/fn/set.js
 ** module id = 713
 ** module chunks = 0
 **/